export const SESSION_KEY = 'DynamoDashboard';
